import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
import { Mail, Instagram } from 'lucide-react';
export function Contacto() {
  return <LegalLayout title="Contacto" data-id="element-285">
      <div className="space-y-8 text-muted-foreground font-light leading-relaxed max-w-xl" data-id="element-286">
        <p className="text-lg" data-id="element-287">
          Estamos aquí para apoyarte en tu proceso. Si tienes dudas sobre la
          colección, problemas técnicos con tu descarga, o simplemente quieres
          compartirnos tu experiencia, nos encantaría leerte.
        </p>

        <div className="bg-card p-8 rounded-2xl border border-border mt-8" data-id="element-288">
          <h3 className="font-serif text-2xl text-foreground mb-6" data-id="element-289">
            Escríbenos
          </h3>

          <div className="space-y-6" data-id="element-290">
            <div className="flex items-start gap-4" data-id="element-291">
              <div className="w-10 h-10 rounded-full bg-secondary/50 flex items-center justify-center shrink-0" data-id="element-292">
                <Mail className="w-5 h-5 text-accent" data-id="element-293" />
              </div>
              <div data-id="element-294">
                <p className="font-medium text-foreground mb-1" data-id="element-295">
                  Soporte por Correo
                </p>
                <a href="mailto:hola@paolarojas.com" className="text-accent hover:text-foreground transition-colors" data-id="element-296">
                  hola@paolarojas.com
                </a>
                <p className="text-sm mt-1" data-id="element-297">
                  Respondemos en un plazo de 24 a 48 horas hábiles.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-298">
              <div className="w-10 h-10 rounded-full bg-secondary/50 flex items-center justify-center shrink-0" data-id="element-299">
                <Instagram className="w-5 h-5 text-accent" data-id="element-300" />
              </div>
              <div data-id="element-301">
                <p className="font-medium text-foreground mb-1" data-id="element-302">Instagram</p>
                <a href="#" className="text-accent hover:text-foreground transition-colors" data-id="element-303">
                  @paolarojassv
                </a>
                <p className="text-sm mt-1" data-id="element-304">
                  Únete a nuestra comunidad y envíanos un mensaje directo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LegalLayout>;
}